import React from "react";
import CustomSpan from "../../components/CustomSpan";
import {formatDate, formatDateTime} from "../../utils/datetime-utils";
import {
  getInspectionResutlColor,
  getInspectionResutlBackground,
  getInspectionResutlSymbol,
} from "../../utils/display-utils";
import {useSelector} from "react-redux";

function InspectionInformationTable({inspection, group}) {
  const resultSymbolSetting = useSelector(
    (s) => s.app_settings.inspection_display.inspection_result_symbol
  );
  const groupSetting = useSelector((s) => s.app_settings.machine_group);
  const countActiveGroups = () => {
    return Object.keys(groupSetting)
      .filter(key => key.startsWith('group'))
      .filter(groupKey => groupSetting[groupKey].active === true)
      .length
  };

  return (
    inspection && (
      <div className="flex flex-col">
        <div className="flex items-center">
          <div className="w-[30px]"></div>
          <div
            className="border-l border-t border-b border-tenken-gray-400 bg-[#E0E0E0] w-[140px] xl:px-[8px] py-[10px] px-[6px]">
            <CustomSpan text="点検結果" className="font-medium"/>
          </div>
          <div
            className="border-l border-t border-b border-tenken-gray-400 bg-white w-[180px] xl:px-[8px] py-[10px] px-[6px]">
                    <span className="font-normal"
                          style={{
                            color: getInspectionResutlColor(
                              inspection.result,
                              resultSymbolSetting
                            ),
                            background: getInspectionResutlBackground(
                              inspection.result,
                              resultSymbolSetting
                            ),
                          }}>
                  {getInspectionResutlSymbol(
                    inspection.result,
                    resultSymbolSetting,
                  )}
                </span>
          </div>
          <div
            className="border-l border-t border-b border-tenken-gray-400 bg-[#E0E0E0] w-[140px] xl:px-[8px] py-[10px] px-[6px]">
            <CustomSpan text="点検履歴ID" className="font-medium"/>
          </div>
          <div
            className="border border-tenken-gray-400 bg-white  xl:px-[8px] py-[10px] px-[6px] w-[180px]">
                    <span className="font-normal">
                      {inspection?.id}
                    </span>
          </div>
        </div>
        <div className="flex">
          <div
            className="border-l border-t border-b border-tenken-gray-400 bg-[#E0E0E0] h-auto w-[30px] flex items-center px-1.5">
            <CustomSpan text="設備" className="font-medium"/>
          </div>
          <div className="flex-col relative">
            <div className="flex">
              <div className="border-l border-b border-tenken-gray-400 bg-[#E0E0E0] xl:px-[8px] py-[10px] px-[6px] w-[140px]">
                <CustomSpan text="点検回数" className="font-medium"/>
              </div>
              <div className="border-l border-b border-tenken-gray-400 bg-white w-[180px] xl:px-[8px] py-[10px] px-[6px]">
                <span className="truncate w-full block font-normal" title={inspection?.inspection_number}>
                  {inspection?.inspection_number}回目
                </span>
              </div>
              <div
                className="border-l border-b border-tenken-gray-400 bg-[#E0E0E0] xl:px-[8px] py-[10px] px-[6px] w-[140px]">
                <CustomSpan text="点検日" className="font-medium"/>
              </div>
              <div
                className="border-l border-b border-r border-tenken-gray-400 bg-white w-[180px] xl:px-[8px] py-[10px] px-[6px]">
                <CustomSpan className="font-normal" text={formatDate(new Date(inspection.execution_date))}/>
              </div>
            </div>
            <div className="flex">
              <div className="flex flex-grow flex-col relative">
                {countActiveGroups() === 1 && (
                  <>
                  <div className="flex flex-col">
                    <div className="flex flex-grow h-[74px]">
                      <div className="border-l border-b border-tenken-gray-400 bg-[#E0E0E0] xl:px-[8px] py-[10px] px-[6px] w-[140px]">
                        <CustomSpan
                          text={groupSetting?.machine?.name}
                          title={groupSetting?.machine?.name}
                          className="font-medium max-w-[140px] truncate block"
                        />
                      </div>
                      <div className="border-l border-b border-tenken-gray-400 bg-white w-[180px] xl:px-[8px] py-[10px] px-[6px]">
                        <span className="truncate w-full block font-normal" title={inspection?.machine?.name}>
                          {inspection?.machine?.name}
                        </span>
                      </div>
                    </div>
                  </div>
                  <div className="flex flex-grow">
                    <div className="border-l border-b border-tenken-gray-400 bg-[#E0E0E0] xl:px-[8px] py-[10px] px-[6px] w-[140px] items-center flex">
                      <CustomSpan
                        text={groupSetting?.group_1?.name}
                        title={groupSetting?.group_1?.name}
                        className="font-medium max-w-[140px] truncate block"
                      />
                    </div>
                    <div className="border-l border-b border-tenken-gray-400 bg-white w-[180px] xl:px-[8px] py-[10px] px-[6px] items-center flex">
                      <CustomSpan className="font-normal truncate w-full block" title={group?.group_1?.name || '-'} text={group?.group_1?.name || '-'}/>
                    </div>
                  </div>
                </>
                )}
                {countActiveGroups() === 2 && (
                  <>
                    <div className="flex flex-col">
                      <div className="flex flex-grow h-[74px]">
                        <div className="border-l border-b border-tenken-gray-400 bg-[#E0E0E0] xl:px-[8px] py-[10px] px-[6px] w-[140px]">
                          <CustomSpan
                            text={groupSetting?.machine?.name}
                            title={groupSetting?.machine?.name}
                            className="font-medium max-w-[140px] truncate block"
                          />
                        </div>
                        <div className="border-l border-b border-tenken-gray-400 bg-white w-[180px] xl:px-[8px] py-[10px] px-[6px]">
                          <span className="truncate w-full block font-normal" title={inspection?.machine?.name}>
                            {inspection?.machine?.name}
                          </span>
                        </div>
                      </div>
                    </div>
                    <div className="flex flex-col">
                      <div className="flex flex-grow h-[74px]">
                        <div className="border-l border-b border-tenken-gray-400 bg-[#E0E0E0] xl:px-[8px] py-[10px] px-[6px] w-[140px]">
                          <CustomSpan
                            text={groupSetting?.group_1?.name}
                            title={groupSetting?.group_1?.name}
                            className="font-medium max-w-[140px] truncate block"
                          />
                        </div>
                        <div className="border-l border-b border-tenken-gray-400 bg-white w-[180px] xl:px-[8px] py-[10px] px-[6px]">
                          <CustomSpan className="font-normal truncate w-full block" title={group?.group_1?.name || '-'} text={group?.group_1?.name || '-'}/>
                        </div>
                      </div>
                    </div>
                    <div className="flex flex-grow">
                      <div className="border-l border-b border-tenken-gray-400 bg-[#E0E0E0] xl:px-[8px] py-[10px] px-[6px] w-[140px] items-center flex">
                        <CustomSpan
                          text={groupSetting?.group_2?.name}
                          title={groupSetting?.group_2?.name}
                          className="font-medium max-w-[140px] truncate block"
                        />
                      </div>
                      <div className="border-l border-b border-tenken-gray-400 bg-white w-[180px] xl:px-[8px] py-[10px] px-[6px] items-center flex">
                        <CustomSpan className="truncate w-full block font-normal" title={group?.group_2?.name || '-'} text={group?.group_2?.name || '-'}/>
                      </div>
                    </div>
                  </>
                )}
                {countActiveGroups() === 3 && (
                  <>
                    <div className="flex flex-grow">
                      <div className="border-l border-b border-tenken-gray-400 bg-[#E0E0E0] xl:px-[8px] py-[10px] px-[6px] w-[140px]">
                        <CustomSpan
                          text={groupSetting?.machine?.name}
                          title={groupSetting?.machine?.name}
                          className="font-medium max-w-[140px] truncate block"
                        />
                      </div>
                      <div className="border-l border-b border-tenken-gray-400 bg-white w-[180px] xl:px-[8px] py-[10px] px-[6px]">
                        <span className="truncate w-full block font-normal" title={inspection?.machine?.name}>
                          {inspection?.machine?.name}
                        </span>
                      </div>
                    </div>
                    <div className="flex flex-grow">
                      <div className="border-l border-b border-tenken-gray-400 bg-[#E0E0E0] xl:px-[8px] py-[10px] px-[6px] w-[140px]">
                        <CustomSpan
                          text={groupSetting?.group_1?.name}
                          title={groupSetting?.group_1?.name}
                          className="font-medium max-w-[140px] truncate block"
                        />
                      </div>
                      <div className="border-l border-b border-tenken-gray-400 bg-white w-[180px] xl:px-[8px] py-[10px] px-[6px]">
                        <CustomSpan className="font-normal truncate w-full block" title={group?.group_1?.name || '-'} text={group?.group_1?.name || '-'}/>
                      </div>
                    </div>
                    <div className="flex flex-col">
                      <div className="flex flex-grow h-[37px]">
                        <div className="border-l border-b border-tenken-gray-400 bg-[#E0E0E0] xl:px-[8px] py-[5px] px-[6px] w-[140px]">
                          <CustomSpan
                            text={groupSetting?.group_2?.name}
                            title={groupSetting?.group_2?.name}
                            className="font-medium max-w-[140px] truncate block"
                          />
                        </div>
                        <div className="border-l border-b border-tenken-gray-400 bg-white w-[180px] xl:px-[8px] py-[5px] px-[6px]">
                          <CustomSpan className="truncate w-full block font-normal" title={group?.group_2?.name || '-'} text={group?.group_2?.name || '-'}/>
                        </div>
                      </div>
                      <div className="flex flex-grow h-[37px]">
                        <div className="border-l border-b border-tenken-gray-400 bg-[#E0E0E0] xl:px-[8px] py-[5px] px-[6px] w-[140px]">
                          <CustomSpan
                            text={groupSetting?.group_3?.name}
                            title={groupSetting?.group_3?.name}
                            className="font-medium max-w-[140px] truncate block"
                          />
                        </div>
                        <div className="border-l border-b border-tenken-gray-400 bg-white w-[180px] xl:px-[8px] py-[5px] px-[6px]">
                          <CustomSpan className="font-normal truncate w-full block" title={group?.group_3?.name || '-'} text={group?.group_3?.name || '-'}/>
                        </div>
                      </div>
                    </div>
                  </>
                )}
                {countActiveGroups() === 4 && (
                  <>
                    <div className="flex flex-grow">
                      <div className="border-l border-b border-tenken-gray-400 bg-[#E0E0E0] xl:px-[8px] py-[10px] px-[6px] w-[140px]">
                        <CustomSpan
                          text={groupSetting?.machine?.name}
                          title={groupSetting?.machine?.name}
                          className="font-medium max-w-[140px] truncate block"
                        />
                      </div>
                      <div className="border-l border-b border-tenken-gray-400 bg-white w-[180px] xl:px-[8px] py-[10px] px-[6px]">
                        <span className="truncate w-full block font-normal" title={inspection?.machine?.name}>
                          {inspection?.machine?.name}
                        </span>
                      </div>
                    </div>
                    <div className="flex flex-col">
                      <div className="flex flex-grow h-[37px]">
                        <div className="border-l border-b border-tenken-gray-400 bg-[#E0E0E0] xl:px-[8px] py-[5px] px-[6px] w-[140px]">
                          <CustomSpan
                            text={groupSetting?.group_1?.name}
                            title={groupSetting?.group_1?.name}
                            className="font-medium max-w-[140px] truncate block"
                          />
                        </div>
                        <div className="border-l border-b border-tenken-gray-400 bg-white w-[180px] xl:px-[8px] py-[5px] px-[6px]">
                          <CustomSpan className="font-normal truncate w-full block" title={group?.group_1?.name || '-'} text={group?.group_1?.name || '-'}/>
                        </div>
                      </div>
                      <div className="flex flex-grow h-[37px]">
                        <div className="border-l border-b border-tenken-gray-400 bg-[#E0E0E0] xl:px-[8px] py-[5px] px-[6px] w-[140px]">
                          <CustomSpan
                            text={groupSetting?.group_2?.name}
                            title={groupSetting?.group_2?.name}
                            className="font-medium max-w-[140px] truncate block"
                          />
                        </div>
                        <div className="border-l border-b border-tenken-gray-400 bg-white w-[180px] xl:px-[8px] py-[5px] px-[6px]">
                          <CustomSpan className="truncate w-full block font-normal" title={group?.group_2?.name || '-'} text={group?.group_2?.name || '-'}/>
                        </div>
                      </div>
                    </div>
                    <div className="flex flex-col">
                      <div className="flex flex-grow h-[37px]">
                        <div className="border-l border-b border-tenken-gray-400 bg-[#E0E0E0] xl:px-[8px] py-[5px] px-[6px] w-[140px]">
                          <CustomSpan
                            text={groupSetting?.group_3?.name}
                            title={groupSetting?.group_3?.name}
                            className="font-medium max-w-[140px] truncate block"
                          />
                        </div>
                        <div className="border-l border-b border-tenken-gray-400 bg-white w-[180px] xl:px-[8px] py-[5px] px-[6px]">
                          <CustomSpan className="font-normal truncate w-full block" title={group?.group_3?.name || '-'} text={group?.group_3?.name || '-'}/>
                        </div>
                      </div>
                      <div className="flex flex-grow h-[37px]">
                        <div className="border-l border-b border-tenken-gray-400 bg-[#E0E0E0] xl:px-[8px] py-[5px] px-[6px] w-[140px]">
                          <CustomSpan 
                            text={groupSetting?.group_4?.name}
                            title={groupSetting?.group_4?.name}
                            className="font-medium max-w-[140px] truncate block"
                          />
                        </div>
                        <div className="border-l border-b border-tenken-gray-400 bg-white w-[180px] xl:px-[8px] py-[5px] px-[6px]">
                          <CustomSpan className="font-normal truncate w-full block" title={group?.group_4?.name || '-'} text={group?.group_4?.name || '-'}/>
                        </div>
                      </div>
                    </div>
                  </>
                )}
                {countActiveGroups() === 5 && (
                  <>
                    <div className="flex flex-grow">
                      <div className="flex flex-grow h-[37px]">
                        <div className="border-l border-b border-tenken-gray-400 bg-[#E0E0E0] xl:px-[8px] py-[5px] px-[6px] w-[140px]">
                          <CustomSpan 
                            text={groupSetting?.machine?.name}
                            title={groupSetting?.machine?.name}
                            className="max-w-[140px] font-medium truncate block"
                          />
                        </div>
                        <div className="border-l border-b border-tenken-gray-400 bg-white w-[180px] xl:px-[8px] py-[5px] px-[6px]">
                          <span className="truncate w-full block font-normal" title={inspection?.machine?.name}>
                            {inspection?.machine?.name}
                          </span>
                        </div>
                      </div>
                    </div>
                    <div className="flex flex-grow">
                      <div className="flex flex-grow h-[37px]">
                        <div className="border-l border-b border-tenken-gray-400 bg-[#E0E0E0] xl:px-[8px] py-[5px] px-[6px] w-[140px]">
                          <CustomSpan 
                            text={groupSetting?.group_1?.name}
                            title={groupSetting?.group_1?.name}
                            className="font-medium block max-w-[140px] truncate"
                          />
                        </div>
                        <div className="border-l border-b border-tenken-gray-400 bg-white w-[180px] xl:px-[8px] py-[5px] px-[6px]">
                          <CustomSpan className="font-normal truncate w-full block" title={group?.group_1?.name || '-'} text={group?.group_1?.name || '-'}/>  
                        </div>
                      </div>
                    </div>
                    <div className="flex flex-col">
                      <div className="flex flex-grow h-[37px]">
                        <div className="border-l border-b border-tenken-gray-400 bg-[#E0E0E0] xl:px-[8px] py-[5px] px-[6px] w-[140px]">
                          <CustomSpan
                            text={groupSetting?.group_2?.name}
                            title={groupSetting?.group_2?.name}
                            className="font-medium block max-w-[140px] truncate"
                          />
                        </div>
                        <div className="border-l border-b border-tenken-gray-400 bg-white w-[180px] xl:px-[8px] py-[5px] px-[6px]">
                          <CustomSpan className="truncate w-full block font-normal" title={group?.group_2?.name || '-'} text={group?.group_2?.name || '-'}/>
                        </div>
                      </div>
                      <div className="flex flex-grow h-[37px]">
                        <div className="border-l border-b border-tenken-gray-400 bg-[#E0E0E0] xl:px-[8px] py-[5px] px-[6px] w-[140px]">
                          <CustomSpan
                            text={groupSetting?.group_3?.name}
                            title={groupSetting?.group_3?.name}
                            className="font-medium block max-w-[140px] truncate"
                          />
                        </div>
                        <div className="border-l border-b border-tenken-gray-400 bg-white w-[180px] xl:px-[8px] py-[5px] px-[6px]">
                          <CustomSpan className="font-normal truncate w-full block" title={group?.group_3?.name || '-'} text={group?.group_3?.name || '-'}/>
                        </div>
                      </div>
                    </div>
                    <div className="flex flex-col">
                      <div className="flex flex-grow h-[37px]">
                        <div className="border-l border-b border-tenken-gray-400 bg-[#E0E0E0] xl:px-[8px] py-[5px] px-[6px] w-[140px]">
                          <CustomSpan
                            text={groupSetting?.group_4?.name}
                            title={groupSetting?.group_4?.name}
                            className="font-medium block max-w-[140px] truncate"
                          />
                        </div>
                        <div className="border-l border-b border-tenken-gray-400 bg-white w-[180px] xl:px-[8px] py-[5px] px-[6px]">
                          <CustomSpan className="font-normal truncate w-full block" title={group?.group_4?.name || '-'} text={group?.group_4?.name || '-'}/>
                        </div>
                      </div>
                      <div className="flex flex-grow h-[37px]">
                        <div className="border-l border-b border-tenken-gray-400 bg-[#E0E0E0] xl:px-[8px] py-[5px] px-[6px] w-[140px]">
                          <CustomSpan
                            text={groupSetting?.group_5?.name}
                            title={groupSetting?.group_5?.name}
                            className="font-medium block max-w-[140px] truncate"
                          />
                        </div>
                        <div className="border-l border-b border-tenken-gray-400 bg-white w-[180px] xl:px-[8px] py-[5px] px-[6px]">
                          <CustomSpan className="font-normal truncate w-full block" title={group?.group_5?.name || '-'} text={group?.group_5?.name || '-'}/>
                        </div>
                      </div>
                    </div>
                  </>
                )}
              </div>
              <div className="flex flex-col justify-between relative">
                <div className="flex flex-grow">
                  <div
                    className="border-l border-b border-tenken-gray-400 bg-[#E0E0E0] xl:px-[8px] py-[10px] px-[6px] w-[140px] flex-grow">
                    <CustomSpan text="点検開始" className="font-medium"/>
                  </div>
                  <div
                    className="border-l border-b border-r border-tenken-gray-400 bg-white w-[180px] xl:px-[8px] py-[10px] px-[6px] flex flex-col flex-grow">
                    <CustomSpan className="font-normal"
                                text={formatDateTime(new Date(inspection.inspection_start_datetime))}/>
                    <div className="group">
                      <span className="truncate w-full inline-block font-normal"
                            title={inspection?.inspection_start_user?.name}>{inspection?.inspection_start_user?.name}</span>
                    </div>
                  </div>
                </div>
                <div className="flex flex-grow">
                  <div
                    className="border-l border-b border-tenken-gray-400 bg-[#E0E0E0] xl:px-[8px] py-[10px] px-[6px] w-[140px] flex-grow">
                    <CustomSpan text="稼働開始" className="font-medium"/>
                  </div>
                  <div
                    className="border-l border-b border-r border-tenken-gray-400 bg-white w-[180px] xl:px-[8px] py-[10px] px-[6px] flex flex-col flex-grow">
                    <CustomSpan className="font-normal"
                                text={inspection.operation_start_datetime ? formatDateTime(new Date(inspection.operation_start_datetime)) : '-'}/>
                    <div className="group">
                      <span className="truncate w-full inline-block font-normal"
                            title={inspection?.operation_start_user?.name}>{inspection?.operation_start_user?.name || '-'}</span>
                    </div>
                  </div>
                </div>
                <div className="flex flex-grow">
                  <div
                    className="border-l border-b border-tenken-gray-400 bg-[#E0E0E0] xl:px-[8px] py-[10px] px-[6px] w-[140px] flex-grow">
                    <CustomSpan text="点検登録" className="font-medium"/>
                  </div>
                  <div
                    className="border-l border-b border-r border-tenken-gray-400 bg-white w-[180px] xl:px-[8px] py-[10px] px-[6px] flex-grow">
                    <CustomSpan className="font-normal"
                                text={formatDateTime(new Date(inspection?.registration_datetime))}/>
                    <div className="group">
                      <span className="truncate w-full inline-block font-normal"
                            title={inspection?.execution_user?.name}>{inspection?.execution_user?.name}</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  );
}

export default InspectionInformationTable;
